import { FatalError } from '@rehaje/errors'
import { getPrototypeOf } from '@rehaje/shared'

import type { Locales } from '@rehaje/errors'

export class FatalAssertInheritError extends FatalError {
  static override locales: Locales = {
    'en-US': 'Register as %s target class %s does not inherit %s base class',
    'zh-CN': '注册为 %s 的目标类 %s 没有继承 %s 基类',
    'zh-HK': '註冊為 %s 的目標類 %s 沒有繼承 %s 基類'
  }

  override name = 'FatalAssertInheritError' as const

  constructor(registerKey: string, registerClass: string, className: string) {
    super(registerKey, registerClass, className)
  }
}

export class FatalAssertInstanceError extends FatalError {
  static override locales: Locales = {
    'en-US': 'Target is not a valid %s class instance',
    'zh-CN': '目标不是合法的 %s 类实例',
    'zh-HK': '目標不是合法的 %s 類實例'
  }

  override name = 'FatalAssertInstanceError' as const

  constructor(className: string) {
    super(className)
  }
}

export class FatalAssertOverrideError extends FatalError {
  static override locales: Locales = {
    'en-US': 'Target class %s does not override %s method',
    'zh-CN': '目标类 %s 没有重载 %s 方法',
    'zh-HK': '目標類 %s 沒有重載 %s 方法'
  }

  override name = 'FatalAssertOverrideError' as const

  constructor(classInstance: any, methodName: string) {
    super(getPrototypeOf(classInstance ?? {})?.constructor?.name, methodName)
  }
}
